export const MODAL_DELETE_DASHBOARD = "deleteDashboard";
